import { t } from '@/locales'

export const floatingMenuHTML = () => `
<button class="floating-menu-trigger el-button--primary" aria-label="${t('open')}">
    <div class="floating-menu-icon">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    </div>
    <span id="floating-menu-badge" class="floating-menu-badge"></span>
</button>
<div class="floating-menu-panel">
    <div class="floating-menu-item" data-action="feedback">
    <div class="floating-menu-item-icon">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
        </svg>
    </div>
    <span class="floating-menu-item-text">${t('feedback')}</span>
    </div>
</div>
`

export const styleTemplate = `
:root {
  --es-color-primary: #409eff;
  --es-color-primary: var(--el-color-primary, var(--es-color-primary));
}

.floating-menu-container {
    position: fixed;
    bottom: 90px;
    right: 30px;
    z-index: 9999;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
    cursor: move;
    user-select: none;
}

.floating-menu-container.dragging {
    cursor: grabbing;
}

.floating-menu-container.dragging .floating-menu-trigger {
    transform: scale(0.95);
}

.floating-menu-container.dragging .floating-menu-panel {
    opacity: 0 !important;
    visibility: hidden !important;
}

.floating-menu-trigger {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: var(--es-color-primary);
    border: none;
    cursor: grab;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(65, 105, 225, 0.4);
    transition: all 0.3s ease;
    position: relative;
}

.floating-menu-trigger:active {
    cursor: grabbing;
}

.floating-menu-trigger:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(65, 105, 225, 0.5);
}

.floating-menu-badge {
    box-sizing: border-box;
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 18px;
    height: 18px;
    background: #ff4444;
    color: white;
    border-radius: 9px;
    font-size: 11px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    pointer-events: none;
    border: 2px solid white;
}

/* 如果 badge 为空或为 0，隐藏它 */
.floating-menu-badge:empty {
    display: none;
}

/* 红点样式（不显示数字） */
.floating-menu-badge.dot {
    min-width: 10px;
    width: 10px;
    height: 10px;
    padding: 0;
    top: 2px;
    right: 2px;
}

.floating-menu-icon {
    width: 22px;
    height: 22px;
    display: grid;
    grid-template-columns: repeat(2, 8px);
    grid-template-rows: repeat(2, 8px);
    gap: 4px;
    justify-content: center;
    pointer-events: none;
}

.floating-menu-icon span {
    background: white;
    border-radius: 2px;
}

.floating-menu-panel {
    position: absolute;
    bottom: 52px;
    right: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    padding: 8px;
    min-width: 160px;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: all 0.3s ease;

}

.floating-menu-container:hover .floating-menu-panel {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
    pointer-events: auto;
}

.floating-menu-item {
    display: flex;
    align-items: center;
    padding: 8px 10px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s ease;
    text-decoration: none;
    color: #333;
}

.floating-menu-item:hover {
    background: #f5f5f5;
}

.floating-menu-item-icon {
    width: 20px;
    height: 20px;
    margin-right: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.floating-menu-item-text {
    font-size: 14px;
    color: #333;
    white-space: nowrap;
}

.floating-menu-divider {
    height: 1px;
    background: #e5e5e5;
    margin: 4px 8px;
}
`
